module.exports = __webpack_public_path__ + "static/media/f1.b471f5ba.png";